module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hsTgi"))).then(() => parcelRequire('1iHdE'));